import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { InAppPurchaseService } from '../services/in-app-purchase.service';
import { Purchases } from '@revenuecat/purchases-capacitor';
import { Platform } from '@ionic/angular';
import { APIRoutes, ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionGuard implements CanActivate {
  private isCapacitor: boolean;

  constructor(
    private api: ApiService,
    private router: Router,
    private platform: Platform,
    private inAppPurchaseService: InAppPurchaseService
  ) {
    this.isCapacitor = this.platform.is('capacitor');
  }

  async canActivate(): Promise<boolean> {
    // Se siamo su mobile (Capacitor)
    if (this.isCapacitor) {
      try {
        const { customerInfo } = await Purchases.getCustomerInfo();
        const activeEntitlements = customerInfo.entitlements.active;

        if ('Marketing Tools' in activeEntitlements) {
          const cosmoreMarketingTools = activeEntitlements['Marketing Tools'];
          console.log(cosmoreMarketingTools);

          this.updateSubscriptionExpireAt(cosmoreMarketingTools.expirationDate);

          if (cosmoreMarketingTools.isActive) {
            return true;
          }
        }
      } catch (error) {
        console.error('Errore durante il recupero customerInfo:', error);
      }

      // fallback API check
      return new Promise<boolean>((resolve) => {
        this.api.get(
          APIRoutes.check_subscription,
          (res: any) => {
            if (res === true) {
              resolve(true);
            } else {
              this.inAppPurchaseService.presentPaywall();
              resolve(false);
            }
          },
          true,
          true
        );
      });
    }

    // Se siamo su web
    return new Promise<boolean>((resolve) => {
      this.api.get(
        APIRoutes.check_subscription,
        (res: any) => {
          if (res === true) {
            resolve(true);
          } else {
            this.router.navigate(['/subscription-required']);
            resolve(false);
          }
        },
        true,
        true
      );
    });
  }

  async updateSubscriptionExpireAt(expireDate: string) {
    this.api.post(
      APIRoutes.update_subscription,
      { newExpireDate: expireDate },
      async (res) => {}
    );
  }
}
